import { useEffect } from 'react'
import { deliverOwnedNotificationHint } from '@/lib/notifications/owned-notification-delivery'
import { useEntityRealtime } from '@/lib/realtime'
import { useNotificationStore } from '@/store/notifications/store'
import { useQueryClient } from '@tanstack/react-query'

import { useNotificationReadSession } from './useNotificationReadSession'

/** Mounted by the browser/native delivery consumer, including feed-only views. */
export function useNotificationDelivery() {
  const session = useNotificationReadSession(),
    client = useQueryClient()
  const organizationId = session.enabled ? session.organizationId : null
  const { addEventListener } = useEntityRealtime(
    'organization',
    organizationId,
    { suppressLogging: true },
  )
  useEffect(() => {
    if (!organizationId) return
    return addEventListener('NOTIFICATION_CREATED', hint => {
      void deliverOwnedNotificationHint(client, session, hint, notification =>
        useNotificationStore.getState().handleNotificationCreated(notification),
      )
    })
  }, [client, session, organizationId, addEventListener])
}
